// i18n area 'common' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.fr-FR.meta.json.
import type { enUS } from './common'

export const frFR: typeof enUS = {
  nav: {
    home: 'Accueil',
    vms: 'Machines virtuelles',
    templates: 'Templates',
    importVms: 'Importer des VM',
    containers: 'Containers',
    containersApps: 'Apps',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Images OCI',
    containersOciRegistries: 'Registries OCI',
    containersCtTemplates: 'Templates CT',
    networkServices: 'Services réseau',
    firewall: 'Pare-feu',
    checkpoints: 'Checkpoints',
    backup: 'Backup',
    monitoring: 'Supervision',
    cluster: 'Cluster',
    clusterSettings: 'Paramètres globaux',
    clusterNodes: 'Nœuds',
    clusterDevices: 'Ressources USB et PCIe',
    clusterFederation: 'Fédération',
    network: 'Réseau',
    overlayNetworks: 'Réseaux overlay',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Données',
    storages: 'Storage',
    hci: 'Hyperconvergence',
    ceph: 'Ceph',
    system: 'Système',
    tasks: 'Tasks',
    events: 'Événements',
    audit: 'Audit',
    diagnostics: 'Diagnostic',
    notifications: 'Notifications',
    proximity: 'TVirt Proximity',
    users: 'Utilisateurs et groupes',
    groups: 'Groupes',
    mfa: 'MFA',
    realms: 'Realms et SSO',
    rbac: 'Rôles et permissions',
    credentials: 'Identifiants',
    scopes: 'Scopes',
    tags: 'Tags',
    explorer: 'Explorer',
    licensing: 'Licence',
    information: 'Informations'
  },
  mode: {
    light: 'Clair',
    dark: 'Sombre',
    system: 'Système',
    tooltip: 'Thème'
  },
  language: {
    tooltip: 'Langue'
  },
  langRegion: {
    europe: 'Europe',
    northAmerica: 'Amérique du Nord',
    southAmerica: 'Amérique du Sud',
    asia: 'Asie'
  },
  notFound: {
    title: 'Page introuvable',
    body: 'Cette adresse ne correspond à aucune page de TVirt — elle a pu changer avec une mise à jour, ou le lien est obsolète.',
    backHome: "Retour à l'Accueil"
  },
  scopeBrowser: {
    title: 'Scopes',
    all: 'Tout le cluster',
    noChildren: 'Aucun sous-scope ici',
    recursive: 'Inclure les descendants',
    collapse: 'Replier le panneau des scopes',
    openPicker: 'Parcourir les scopes',
    up: "Remonter d'un niveau",
    countTooltip: '{direct} dans ce scope · {total} avec les descendants'
  },
  search: {
    tooltip: 'Rechercher (⌘K)',
    placeholder: 'Rechercher VM, réseaux, storage…',
    empty: 'Aucun résultat',
    groups: {
      recent: 'Récents',
      shortcuts: 'Raccourcis',
      actions: 'Actions',
      goTo: 'Aller à'
    },
    kind: {
      catalog: 'Catalogue',
      scope: 'Scope',
      node: 'Nœud'
    },
    footer: {
      navigate: 'naviguer',
      open: 'ouvrir',
      close: 'fermer'
    },
    actions: {
      createVm: 'Créer une VM…',
      uploadIso: 'Téléverser une ISO…',
      clusterSettings: 'Paramètres du cluster',
      consoleOf: 'Aller à la console de {name}'
    }
  },
  stub: {
    containersSummary: 'Applications et containers système (CT), avec leurs images OCI, leurs registries et leurs templates — gérés aux côtés de vos VM.',
    sectionSummary_vms: 'Machines virtuelles et leurs templates — cycle de vie, snapshots, migration et consoles.',
    sectionSummary_storages: 'Les storages où vivent les disques, les images et les métadonnées des VM.',
    sectionSummary_catalogs: 'La maison des artefacts fichiers du cluster : images ISO, templates CT et VM et archives OCI, organisés en catalogues.',
    sectionSummary_overlay: 'Réseaux overlay VXLAN entre les nœuds du cluster.',
    sectionSummary_fabric: "L'inventaire du réseau physique — switch, ports, LAGG et réseaux logiques.",
    sectionSummary_ipam: "L'adressage dérivé des réseaux fabric et overlay : qui détient chaque adresse.",
    sectionSummary_services: 'Serveurs DHCP et DNS dérivés du registre réseau.',
    sectionSummary_ceph: 'Clusters Ceph gérés sur les nœuds TVirt.',
    sectionSummary_hci: 'Les technologies de storage hyperconvergé sur les nœuds TVirt.',
    sectionSummary_cluster: 'Nœuds, appartenance et paramètres de cluster.',
    containers: 'Les containers système sont sur la roadmap — cette section les accueillera.',
    containersApps: 'Les applications containerisées sont sur la roadmap — cette zone les accueillera.',
    containersPods: 'Les pods regroupent des conteneurs partageant réseau et volumes — les instances sont les apps.',
    containersCt: 'Les containers système (CT) sont sur la roadmap — cette zone les accueillera.',
    multiscsi: "TVStor MultiSCSI est sur la roadmap — cette zone l'accueillera.",
    clusterFederation: "La fédération entre clusters TVirt est sur la roadmap — cette zone l'accueillera.",
    containersOciImages: 'Les images OCI sont sur la roadmap — cette zone les accueillera.',
    containersOciRegistries: 'Les registries OCI sont sur la roadmap — cette zone les accueillera.',
    containersCtTemplates: 'Les templates CT sont sur la roadmap — cette zone les accueillera.',
    importVms: 'Les importers ESXi et Proxmox arriveront ici : conversion des guests et migration en masse dans TVirt.',
    backup: "Le backup intégré arrive avec la 6.2 : repositories content-addressed dédupliqués, incrémentaux CBT, fenêtres d'immutabilité et réplication repo-to-repo.",
    monitoring: "Les dashboards de contention cluster-wide (cpu.ready, pression PSI, alertes intégrées) arrivent — aujourd'hui les mêmes métriques vivent dans les détails de chaque VM."
  },
  home: {
    welcome: 'Vous êtes connecté avec le compte : {name}',
    subtitle: "Voici votre cluster TVirt en un coup d'œil.",
    loadError: "Impossible de charger la vue d'ensemble — le backend TVirt est-il joignable ?",
    health: {
      ok: 'Tout va bien',
      warning: 'Attention',
      critical: 'Problèmes critiques'
    },
    reason: {
      'node-down': '{subject} est éteint',
      'node-stale': '{subject} ne donne plus signe de vie depuis un moment',
      'node-maintenance': '{subject} en maintenance',
      'tasks-failed': {
        one: '{n} task échouée dans les dernières 24h',
        many: '{n} tasks échouées dans les dernières 24h',
        other: '{n} tasks échouées dans les dernières 24h'
      },
      'storage-degraded': 'storage {subject} dégradé',
      'storage-error': 'storage {subject} en erreur',
      'ceph-warning': 'Ceph {subject} : HEALTH_WARN',
      'ceph-error': 'Ceph {subject} : HEALTH_ERR',
      'store-unreachable': 'store du cluster injoignable',
      'license-absent': 'aucune licence — les nouvelles VM ne peuvent pas démarrer',
      'license-expired': 'licence expirée — les nouvelles VM ne peuvent pas démarrer',
      'license-exceeded': 'limite de licence dépassée — les nouvelles VM ne peuvent pas démarrer',
      'failover-reserve-eroded': 'réserve de failover presque consommée',
      'failover-reserve-exhausted': 'réserve de failover épuisée — les nouvelles VM ne peuvent pas démarrer',

      'oci-cache-nearly-full': 'cache OCI presque plein sur {subject} — les digest s’évincent à la main',
      'oci-cache-full': 'cache OCI plein sur {subject} — aucun pull ne réussira tant que des digest ne sont pas évincés',
      'config-replica-empty': "réplica de configuration VIDE sur {subject} — le nœud n'a aucune configuration du cluster tant qu'une réplication n'aboutit pas",
      'config-replica-stalled': 'réplication de configuration bloquée sur {subject} — la copie locale est en retard sur la configuration du cluster'
    },
    staleChip: 'Données pas à jour',
    staleAsOf: 'dernière réplication {time}',
    zone: {
      nodes: 'Nœuds',
      failoverReserve: 'Réserve de failover',
      capacity: 'Capacité',
      workload: 'Charge de travail',
      protection: 'Protection',
      activity: 'Activité récente'
    },
    reserve: {
      state: {
        ok: 'Réserve intacte',
        eroded: 'Réserve presque consommée',
        exhausted: 'Réserve épuisée',
        unknown: 'Réserve inconnue'
      },
      tolerate: {
        one: 'tolère la perte de {n} nœud',
        many: 'tolère la perte de {n} nœuds',
        other: 'tolère la perte de {n} nœuds'
      },
      usedOf: '{used} / {allowed} GiB utilisés',
      keepFree: '{n} GiB gardés libres pour le failover',
      expendable: 'dont {n} sacrifiables en service',
      headroom: '{n} GiB peuvent encore être démarrés',
      short: 'il manque {n} GiB à la réserve — les nouvelles VM ne peuvent pas démarrer',
      hp: {
        usedOf: 'Pages de {size} — en usage : {used} / {allowed}',
        keepFree: 'gardées libres pour le failover : {keep}',
        headroom: 'encore démarrables : {n}',
        short: 'manquantes à la réserve : {n} — les nouvelles VM à pages énormes ne peuvent pas démarrer'
      },
      worstCase: 'pire cas : {nodes}',
      unavailable: '{node} : {reason}',
      unknown: "Aucun nœud n'a encore déclaré sa mémoire — la réserve n'est pas calculable et aucun démarrage n'est refusé.",
      reason: {
        attestedDown: 'attesté éteint',
        maintenance: 'en maintenance',
        unreachable: 'injoignable',
        capacityUnknown: 'mémoire non déclarée'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} cores / {threads} threads',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} VM active',
        many: '{n} VM actives',
        other: '{n} VM actives'
      },
      activeVmsUnknown: 'VM actives inconnues',
      lastSeen: 'vu {time}',
      neverSeen: 'jamais vu',
      down: 'Éteint',
      maintenance: 'Maintenance',
      stale: 'Injoignable'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisionnés',
      reserve: 'réserve {n} GiB',
      unobserved: 'capacité pas encore observée',
      empty: 'Aucun storage pour le moment'
    },
    workload: {
      vms: 'Machines virtuelles',
      apps: 'Apps',
      services: 'Services réseau',
      empty: 'Encore rien',
      phasesUnknown: 'répartition par phase indisponible'
    },
    protection: {
      none: 'Aucune destination de backup configurée — protégez votre configuration.',
      configure: 'Configurer les checkpoints',
      noRuns: 'Aucun checkpoint n\'a encore été créé.',
      last: 'Dernier checkpoint',
      onTarget: 'sur {target}',
      viewAll: 'Checkpoints'
    },
    activity: {
      empty: 'Aucune activité récente',
      failed24: {
        one: '{n} échouée en 24h',
        many: '{n} échouées en 24h',
        other: '{n} échouées en 24h'
      },
      viewAll: 'Voir toutes les tasks'
    }
  },
  notes: {
    title: 'Notes',
    tabEdit: 'Modifier',
    tabPreview: 'Aperçu',
    placeholder: "Notes libres de l'opérateur — le Markdown est rendu dans l'aperçu",
    empty: 'Aucune note',
    tooLarge: 'Les notes dépassent la limite de 64 KiB',
    saveError: "L'enregistrement des notes a échoué"
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'La réponse du backend contient une valeur que cette interface ne connaît pas : {field}={value} — mettez à jour l\'interface web vers la version du backend.',
    contractErrorItems: '{count} objets de cette liste ne peuvent pas être lus par cette interface ({field}={value}) et ne sont pas affichés.',
    staleHint: "Le store n'est pas joignable — ceci est la réplique de config de ce nœud ; l'état de la flotte est inconnu.",
    staleStateAge: 'état au {time}',
    staleStateNever: 'état jamais reçu du store : vous ne voyez que les observations de ce nœud',
    staleStateTooltip: "Le store du cluster n'est pas joignable : l'état observé (phase, nœud, agent) provient de la réplique d'état de ce nœud et date de la dernière lecture réussie du store — il peut être obsolète.",
    noPermission: "Vous n'avez pas la permission pour cette action",
    actionStillRunning: 'L\'action est toujours en cours — son issue n\'est pas encore connue',
    staleWrite: "Quelqu'un d'autre a modifié cet objet pendant que vous l'éditiez — rien n'a été écrit. Rechargez et répétez votre modification sur l'état à jour.",
    staleReload: 'Recharger',
    preview: 'Aperçu',
    previewTitle: 'Aperçu du résultat',
    previewNothingWritten: 'Simulé sur le serveur — rien n\'a été écrit.',
    previewChanged: 'En évidence : les valeurs qui changeraient.'
  },
  context: {
    copySelection: 'Copier le texte sélectionné'
  },
  crud: {
    create: 'Créer',
    viewDetails: 'Voir les détails',
    viewOrEdit: 'Voir ou modifier',
    selected: 'sélectionnés',
    viewUsingVms: 'Voir les VM qui utilisent la ressource',
    clearSelection: 'Désélectionner',
    deleteSelected: 'Supprimer la sélection',
    bulkConfirmBody: {
      one: "Supprimer {count} élément sélectionné ? S'il est protégé, il sera signalé et conservé.",
      many: 'Supprimer les {count} éléments sélectionnés ? Les éléments protégés seront signalés et conservés.',
      other: 'Supprimer les {count} éléments sélectionnés ? Les éléments protégés seront signalés et conservés.'
    },
    bulkDeleted: 'supprimés',
    bulkRefused: 'refusés',
    fieldId: 'ID',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    immutableField: "Fixé à la création — le contract n'en permet pas la modification",
    immutableScope: "Le scope s'assigne à la création ; certaines ressources se déplacent via une action dédiée",
    observedField: 'État observé — rapporté par la plateforme, non modifiable'
  }
}
